import axiosInstance from "../../axios/index";
import axios from "axios";
import { alertSuccess } from "../../utils/feedback";
import {
  SELECT_REPORT,
  SET_ALL_REPORTS,
  SET_UUID_REPORT,
} from "../types/reportsTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const selectReport = (item) => ({ type: SELECT_REPORT, payload: item });

export const setAllReports = (item) => ({
  type: SET_ALL_REPORTS,
  payload: item,
});

export const setUuidReport = (id) => ({ type: SET_UUID_REPORT, payload: id });

export const fetchReportById = (id, accountType, orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted());

    try {
      // const res = token
      //   ? accountType === "enterprise"
      //     ? await axiosInstance.get(`/calculator/${id}?orga_id=${orgaId}`)
      //     : await axiosInstance.get(`/calculator/${id}`)
      //   : await axiosInstance.get(`/calculator_off/${id}`);

      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(`/calculator/${id}?orga_id=${orgaId}`)
          : await axiosInstance.get(`/calculator/${id}`);
      dispatch(requestSucceeded());
      const item = res.data;
      dispatch(selectReport(item));
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchAllReports = (accountType, orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted("report"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(`calculator/list_reports?orga_id=${orgaId}`)
          : await axiosInstance.get(`calculator/list_reports`);
      const allReports = await res?.data?.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );

      dispatch(setAllReports(allReports));
      // if (allReports.length !== 0) {
      dispatch(setUuidReport(allReports[0]?.uuid));
      // }
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestContactExpert = (url, accountType, orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      // const res = token
      //   ? accountType === "enterprise"
      //     ? await axiosInstance.post(
      //         `/calculator/send_notifications?orga_id=${orgaId}
      // `,
      //         {
      //           url: url,
      //         }
      //       )
      //     : await axiosInstance.post(
      //         `/calculator/send_notifications
      // `,
      //         {
      //           url: url,
      //         }
      //       )
      //   : await axiosInstance.post(
      //       `/calculator/send_notifications_off
      // `,
      //       {
      //         url: url,
      //       }
      //     );

      const res =
        accountType === "enterprise"
          ? await axiosInstance.post(
              `/calculator/send_notifications?orga_id=${orgaId}
        `,
              {
                url: url,
              }
            )
          : await axiosInstance.post(
              `/calculator/send_notifications
        `,
              {
                url: url,
              }
            );
      dispatch(requestSucceeded());
      if (res.data) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestConsultReport = (id, apiKey) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/calculator/consult_report/${id}`,
        {
          "api-key": apiKey,
        }
      );
      dispatch(requestSucceeded());
      const item = res.data;
      dispatch(selectReport(item));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestGenerateFiles = (orgaId, uuid, lang) => {
  return async (dispatch) => {
    const language = lang.indexOf("fr") !== -1 ? "fr" : "en";
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(
        `/calculator/export_report?orga_id=${orgaId}&language=${language}`,
        { uuid }
      );
      dispatch(requestSucceeded());
      if (res) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export function getListOfAllReports(orgaId, showGlobalLoading = true) {
  return async (dispatch) => {
    const normalizedOrgaId =
      orgaId !== undefined && orgaId !== null ? String(orgaId).trim() : "";

    dispatch(setAllReports([]));

    if (
      !normalizedOrgaId ||
      normalizedOrgaId.toLowerCase() === "null" ||
      normalizedOrgaId.toLowerCase() === "undefined"
    ) {
      return;
    }

    if (showGlobalLoading) {
      dispatch(requestStarted());
    }
    try {
      const res = await axiosInstance.get(`/survey/reports/${normalizedOrgaId}`);
      console.log("All Reports Response:", res?.data?.reports);
      dispatch(setAllReports(res?.data?.reports || []));
      if (showGlobalLoading) {
        dispatch(requestSucceeded());
      }
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export function requestEvidencePack(orgaId, reportId) {
  return async (dispatch) => {
    const normalizedOrgaId =
      orgaId !== undefined && orgaId !== null ? String(orgaId).trim() : "";
    const normalizedReportId =
      reportId !== undefined && reportId !== null ? String(reportId).trim() : "";

    if (!normalizedOrgaId || !normalizedReportId) {
      throw new Error("Missing organization id or report id");
    }

    try {
      const res = await axiosInstance.post(
        `/survey/evidence-pack-request/${normalizedOrgaId}/${encodeURIComponent(
          normalizedReportId
        )}`
      );
      const data = res?.data || {};
      // Only the fresh "generation started" response carries a message; the
      // already-in-progress / completed responses do not.
      if (data.message || data.message_fr) {
        alertSuccess(data);
      }
      return data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      throw error;
    }
  };
}

export function downloadEvidencePack(orgaId, reportId) {
  return async (dispatch) => {
    const normalizedOrgaId =
      orgaId !== undefined && orgaId !== null ? String(orgaId).trim() : "";
    const normalizedReportId =
      reportId !== undefined && reportId !== null ? String(reportId).trim() : "";

    if (!normalizedOrgaId || !normalizedReportId) {
      throw new Error("Missing organization id or report id");
    }

    try {
      const res = await axiosInstance.get(
        `/survey/evidence-pack-download/${normalizedOrgaId}/${encodeURIComponent(
          normalizedReportId
        )}`
      );
      const data = res?.data;
      if (!data || typeof data !== "object") {
        throw new Error("Evidence Pack download authorization failed");
      }
      if (typeof data.download_path === "string") {
        if (!data.download_path.startsWith("/survey/evidence-pack-file/")) {
          throw new Error("Evidence Pack download path is invalid");
        }
        const apiBase = String(process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
        return { ...data, download_url: `${apiBase}${data.download_path}` };
      }
      return data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      throw error;
    }
  };
}
